import { EncomMapResponse } from '../types';

const getApiBaseUrl = (): string => {
  const environment = process.env.REACT_APP_ENVIRONMENT || 'dev';
  
  if (environment === 'prod') {
    return 'https://encom-api.riperoni.com';
  }
  
  // Use dev API endpoint with custom domain
  return 'https://encom-api-dev.riperoni.com';
};

const getApiKey = (): string | undefined => {
  return process.env.REACT_APP_API_KEY;
};

export class EncomMapService {
  private baseUrl: string;
  private apiKey?: string;

  constructor() {
    this.baseUrl = getApiBaseUrl();
    this.apiKey = getApiKey();
  }

  async generateMap(hexagonCount: number = 500, seed?: string | number): Promise<EncomMapResponse> {
    const headers: Record<string, string> = {
      'Content-Type': 'application/json',
    };

    if (this.apiKey) {
      headers['X-API-Key'] = this.apiKey;
    }

    const requestBody: any = {
      hexagonCount: Math.min(hexagonCount, 1000),
    };

    if (seed !== undefined) {
      requestBody.seed = seed;
    }

    const response = await fetch(`${this.baseUrl}/api/v1/map/generate`, {
      method: 'POST',
      headers,
      body: JSON.stringify(requestBody),
    });

    if (!response.ok) {
      throw new Error(`Failed to generate map: ${response.status} ${response.statusText}`);
    }

    const data = await response.json();
    return data;
  }

  async getMapStatus(mapId: string): Promise<{ status: string; progress?: number }> {
    const headers: Record<string, string> = {};

    if (this.apiKey) {
      headers['X-API-Key'] = this.apiKey;
    }

    const response = await fetch(`${this.baseUrl}/api/v1/map/status/${mapId}`, {
      headers,
    });

    if (!response.ok) {
      throw new Error(`Failed to get map status: ${response.status} ${response.statusText}`);
    }

    return response.json();
  }
}

export const mapService = new EncomMapService();